import React from 'react';
export function AbismoSection() {
  return <section className="relative w-full py-12 md:py-16 px-4 bg-black" data-id="element-1">
      {/* Subtle top divider */}
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#C5A014]/20 to-transparent" data-id="element-2" />

      <div className="max-w-3xl mx-auto text-center space-y-5" data-id="element-3">
        <h2 className="font-['Playfair_Display'] font-bold text-3xl md:text-5xl text-[#B8B8B8] tracking-tight" data-id="element-4">
          El Abismo del Sur
        </h2>

        <p className="font-['Crimson_Text'] text-lg md:text-2xl text-zinc-400 leading-relaxed" data-id="element-5">
          Mientras todos miraban a Colombia y México, el verdadero poder crecía
          en <span className="text-[#C5A014] font-semibold" data-id="element-6">Montevideo</span>.
          Ministros, fiscales y agentes de inteligencia jugaban en un tablero
          diseñado por un solo hombre.
        </p>

        <p className="font-['Crimson_Text'] text-lg md:text-2xl text-zinc-400 leading-relaxed" data-id="element-7">
          Este no es un thriller de ficción; es la{' '}
          <span className="text-zinc-200 font-semibold" data-id="element-8">
            radiografía de un sistema que fue hackeado desde adentro
          </span>
          . Si crees que sabes cómo se entregó aquel pasaporte en Dubái,
          prepárate para leer lo que los medios no pudieron publicar.
        </p>
      </div>

      {/* Subtle bottom divider */}
      <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-zinc-800/50 to-transparent" data-id="element-9" />
    </section>;
}